module.exports = __webpack_public_path__ + "static/media/about-jobs.a5ca34b2.jpg";